"use client";
import { useTranslations } from "next-intl";
import useProductPriceInfo from "../hooks/useProductPriceInfo";
import Price from "../../common/components/Price";
import Loading from "../../common/components/Loading";
import MigelConformity from "./MigelConformity";
import useCurrentUser from "../../auth/hooks/useCurrentUser";
import useMigelConformity from "../hooks/useMigelConformity";

const ProductPriceInfo = ({
  productId,
  appearance = "card",
}: {
  productId: string;
  appearance?: "card" | "inline";
}) => {
  const t = useTranslations();
  const { currentUser } = useCurrentUser();
  const { price, loading, migelConformity } = useProductPriceInfo({
    productId,
    configuration: currentUser?.currentClient?._id
      ? [
          {
            key: "clientId",
            value: currentUser?.currentClient?._id,
          },
        ]
      : [],
    shouldUseInstitutionalMigelConformity:
      currentUser?.currentClient?.isInstitution,
  });

  const [, title] = useMigelConformity(migelConformity);

  if (!price) return null;

  if (appearance === "inline") {
    return (
      <>
        <Price className="color-primary-dimmed" {...price} />
        <MigelConformity migelConformity={migelConformity} />
      </>
    );
  }

  return (
    <div className="row mt-5">
      {loading ? (
        <Loading size="sm" className="w-auto" />
      ) : (
        <div className="col-xl-6">
          <span className="h6">
            <Price {...price} />
          </span>{" "}
          <span className="fs-7">{t("including_tax")}</span>
        </div>
      )}

      <div className="col-xl-6 fs-7">
        <div className="d-flex align-items-center gap-2">
          <MigelConformity migelConformity={migelConformity} />
          <div>{title}</div>
        </div>
      </div>
    </div>
  );
};

export default ProductPriceInfo;
